export default __webpack_public_path__ + "static/media/image.shell-invent-information-technologies-pvt-ltd.105c047b.png";